<div class="relative mt-5">
  <div
    class="text-black text-sm font-semibold leading-snug absolute top-[-8px] left-[10px] px-[10px] bg-white"
  >
    Ownership*
  </div>
  <div class="w-full border-[2px] border-solid border-[#14192D] rounded-[4px] p-3 flex flex-col justify-start items-center">
      <ark-radio-group
        class="mt-[10px] w-full"
        [options]="options"
        variant="ownership"
        [selectedOwnership]="selectedOwnership"
        (valueChanged)="onOwnershipChange($event.value)"
        (infoBubbleClicked)="openOwnershipModal($event)"
      ></ark-radio-group>
      @if (selectedOwnership === 'single' || selectedOwnership === 'multiple') { 
      <div class="flex items-center justify-between gap-3 mt-3 w-full">
        <div class="flex items-center gap-3 min-w-0 flex-1">
          <div class="w-[50px] h-[50px] shrink-0">
            <img
              class="w-full h-full rounded-full object-cover"
              [src]="founderData.icon || founderData.nft || 'https://www.gravatar.com/avatar/?d=mp'"
              alt="{{ founderData.nickname }}'s profile"
            />
          </div>
          <div class="flex flex-col min-w-0">
            <span class="text-sm font-semibold text-gray-800 truncate">
              {{ '@' + founderData.nickname }}
            </span>
            <span class="text-[12px] leading-[20px] font-normal text-[#565761] truncate">
              {{ founderData.firstName }} {{ founderData.lastName }}
            </span>
            <!-- <span class="text-[12px] leading-[20px] font-normal text-[#565761] truncate">
              {{ founderData.status || 'accepted' }}
            </span> -->
          </div>
        </div>
        <div class="flex items-center gap-2 w-[120px] justify-end">
          <ark-input
            label="%"
            size="small"
            [value]="founderPercentage"
            [readonly]="true"
            [hideIcons]="true"
            class="w-[55px] !min-w-0 !max-w-[55px] h-[30px] !min-h-[30px]"
          ></ark-input>
        </div>
      </div>
      }
      
      @if (selectedOwnership === 'multiple') {
        <!-- Added Founders -->

        <div *ngIf="selectedFounders.length > 0 " class="mt-3 w-full">

            <div *ngFor="let Founder of selectedFounders" class="w-full">
              <div
                class="flex items-center justify-between border-b border-gray-200 pb-2 last:border-b-0 w-full"
              >
                <div class="flex items-center gap-3">
                  <div class="w-[50px] h-[50px]">
                    <img
                      class="w-full h-full rounded-full object-cover"
                      [src]="Founder?.icon || Founder?.nft || 'https://www.gravatar.com/avatar/?d=mp'"
                      alt="{{ Founder?.nickname }}'s profile"
                    />
                  </div>
                  <div class="flex flex-col min-w-0">
                    <span class="text-sm font-semibold text-gray-800 truncate">
                      {{ '@' + Founder?.nickname }}
                    </span>
                    <div *ngIf="(Founder?.status || 'invited').toLowerCase() !== 'accepted'" class="flex flex-row items-center justify-start gap-1">
                      <ark-lib-icon-name
                        [name]="(Founder?.status || 'invited').toLowerCase() === 'invited' ? 'contact' : 'contact-red'"
                      ></ark-lib-icon-name>
                      <span
                        class="text-[12px] leading-[20px] font-normal truncate"
                        [ngClass]="(Founder?.status || 'invited').toLowerCase() === 'invited' ? 'text-[#565761]' : 'text-[#C83764]'"
                      >
                        {{ (Founder?.status || 'Invited') | firstLetterUppercase }}
                      </span>
                    </div>
                  </div>
                </div>

                 <div class="flex items-center gap-2 w-[120px] justify-end shrink-0">
                    <ark-input
                      label="%"
                      size="small"
                      [value]="Founder.percentage | number:'1.0-2'"
                      [hideIcons]="true"
                      [readonly]="readOnly"
                      (valueChanged)="!readOnly && updateFounderPercentage(Founder, $event.value)"
                      class="w-[50px] !min-w-0 !max-w-[50px] h-[30px] !min-h-[30px]"
                    ></ark-input>

                    <button
                      *ngIf="!readOnly"
                      class="ml-auto p-2 w-[36px] h-[30px] flex items-center justify-center"
                      style="border: 1px solid #c8c8cd; border-radius: 4px"
                      (click)="removeFounder(Founder)"
                    >
                      <ion-icon name="close-outline"></ion-icon>
                    </button>
                  </div>
              </div>

              <div *ngIf="Founder.inputError"
                class="text-pink-600 text-sm font-medium leading-normal mt-1 ml-[70px]">
                {{ Founder.inputError }}
              </div>
            </div>
          </div>

        <ark-button 
          class="mt-3 w-full"
          type="neutral"
          leftIcon="system-plus"
          iconColor="cta"
          (click)="onAddFounderButtonClick()"
        >ADD FOUNDER
      </ark-button>
      }
  </div>
</div>

 <div *ngIf="createService.validations['founders'].error"
     class="text-pink-600 text-sm font-medium mt-2">
  {{ createService.validations['founders'].error }}
</div>